import React from "react";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import fscLogo from "src/assets/images/logos/fsc_logo.jpg";
import { color } from "src/styles/variables";

function CompanyBadges() {
  return (
    <Section>
      <ImagesWrapper>
        <LazyLoad height={100} offset={100} once>
          <Image
            src={fscLogo}
            alt="Forests for all forever"
            width="448"
            height="200"
          />
        </LazyLoad>
      </ImagesWrapper>
    </Section>
  );
}

export default CompanyBadges;

const Section = styled.section`
  padding-top: 20px;
  background-color: ${color.white};
`;

const ImagesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  max-width: 700px;
  margin: 0 auto;
`;

const Image = styled.img`
  height: 100px;
  width: auto;
  margin: 10px 30px 30px;
`;
